import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { usePrefetchCart } from "@faire/retailer-visitor-shared/features/Cart/useCart";
import { usePrefetchCartSummary } from "@faire/retailer-visitor-shared/hooks/cart/useCartSummary";
import { route as cartRoute } from "@faire/web-api--source/routes/cart";
import cartPath from "@faire/web-api--source/routes/cart";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
export var useCartPrefetch = function() {
    var history = useHistory();
    var prefetchActiveCart = usePrefetchCart().prefetchActiveCart;
    var prefetchActiveCartSummary = usePrefetchCartSummary().prefetchActiveCartSummary;
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    return useCallback(function() {
        var href = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : cartRoute;
        if (history.location.pathname !== cartPath()) {
            nextPrefetch(href, {
                kind: PrefetchKind.FULL
            });
            prefetchActiveCart();
            prefetchActiveCartSummary();
        }
    }, [
        history.location.pathname,
        nextPrefetch,
        prefetchActiveCart,
        prefetchActiveCartSummary
    ]);
};
